/**
 * Logout View
 */

define(function(require, exports, module) {
    'use strict';
    var core = require('core');
    var BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        events: {
            'tap .fn-logout': 'logout'
        },

        render: function() {
            this.$el.html(this.tmpl('logout'));

            return this;
        },

        /**
         * Start logout action
         */
        logout: function() {
            core.trigger('auth:action:logout');
        }

    }, {
        nameOfReplacers: [
            'LOGOUT'
        ]
    });
});